/**
 * OS TEXTOS CANÔNICOS da biblioteca (08/10/2026): o que a tela diz em cada estado da carga. Moram aqui, e as peças
 * (EstadoDaLista, opcaoAtualDoSelect, mensagemDoErroDeCarga) os usam; a tela que chama a peça não escreve estas
 * frases. Mudar uma frase aqui muda todas as telas de uma vez, e o controle `textosCanonicos.test.tsx` diz qual.
 *
 * A regra que as frases carregam: não há "nenhum" onde não houve leitura, e não há `0` onde ninguém contou.
 */
export const textos = {
  carregando: (oQue: string) => `Carregando ${oQue}…`,
  tentarDeNovo: 'Tentar de novo',

  /** Erro, sem dados: a tela diz que NÃO CONSEGUIU, e que isso não é o vazio. */
  naoConseguiCarregar: (oQue: string) => `Não consegui carregar ${oQue}.`,
  // Não depende de `oQue` de propósito (08/10/2026): "Isto não quer dizer que não há os leads" quebrava com o artigo
  // de qualquer lista. A frase diz o que importa sem montar gramática por cima do nome.
  issoNaoEVazio: 'A lista não chegou; não é que esteja vazia.',

  /** Recarga que falha: a lista que estava certa FICA, e a faixa diz de quando ela é. */
  naoConseguiAtualizar: (oQue: string, erro: string | null) => `Não consegui atualizar ${oQue}: ${erro}.`,
  daUltimaCargaBoa: (quando: string) => ` A lista abaixo é a da última carga que deu certo, de ${quando}.`,
  /** O mesmo, para números (cartões de resumo) que ficaram na tela depois da recarga que falhou. */
  numerosDaUltimaCargaBoa: (quando: string) => ` Os números abaixo são da última carga que deu certo, de ${quando}.`,

  /** Lote parcial: o que faltou, nomeado. */
  listaIncompleta: (faltaram: string[] | undefined, erro: string | null) => {
    const n = faltaram?.length ?? 0;
    return `A lista abaixo está INCOMPLETA: ${n} não ${n === 1 ? 'carregou' : 'carregaram'}`
      + `${faltaram?.length ? ` (${faltaram.join(', ')})` : ''}: ${erro}.`;
  },

  /** A opção já escolhida de um select cuja lista não chegou. */
  listaNaoCarregouNoRotulo: ' (lista não carregou)',

  /** O motivo da falha (mensagemDoErroDeCarga). */
  servidorRespondeu: (status: number | string, texto?: string) => `o servidor respondeu ${status}${texto ? `: ${texto}` : ''}`,
  servidorNaoRespondeu: 'o servidor não respondeu. Pode ser uma atualização do sistema em andamento; tente de novo em alguns minutos',
  /** O prazo da requisição passou (services/prazoDaRequisicao): a resposta não veio, o que não quer dizer que falhou. */
  servidorNaoRespondeuNoPrazo: (segundos: number) => `o servidor não respondeu em ${segundos} s`,
  erroDesconhecido: 'erro desconhecido',

  /** Número sem fonte: nunca `0` nem `R$ 0,00`. */
  numeroSemFonte: '—',
} as const;
